import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.card || 'white'};
  border-radius: ${({ theme }) => theme.borderRadius.lg || '8px'};
  box-shadow: ${({ theme }) => theme.shadows.sm || '0 1px 3px rgba(0, 0, 0, 0.1)'};
  padding: ${props => props.padding || '20px'};
  margin-bottom: ${props => props.marginBottom || '0'};
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing[4] || '15px'};
`;

const CardTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.sizes.lg || '1.1rem'};
  font-weight: ${({ theme }) => theme.typography.weights.semibold || '600'};
  color: ${({ theme }) => theme.colors.text.primary || '#1e293b'};
  margin: 0;
`;

const CardContent = styled.div``;

const Card = ({ 
  title, 
  children, 
  action, 
  padding, 
  marginBottom 
}) => {
  return (
    <CardContainer padding={padding} marginBottom={marginBottom}>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {action && action}
        </CardHeader>
      )}
      <CardContent>
        {children}
      </CardContent>
    </CardContainer>
  );
};

export default Card;
